import { makeStyles } from '@material-ui/core';

import {
  containerFluid,
  dangerColor,
  defaultBoxShadow,
  defaultFont,
  infoColor,
  primaryColor,
  successColor,
  warningColor,
} from 'assets/jss/material-dashboard-pro-react';
import THEME from '../../constants/theme';

export const useHeaderStyle = makeStyles(theme => ({
  appBar: {
    backgroundColor: theme.palette.common.white,
    boxShadow      : '0px 1px 0px #cdcfd5',
    borderBottom   : '0',
    marginBottom   : '0',
    position       : 'absolute',
    width          : '100%',
    paddingTop     : '0px',
    zIndex         : '1029',
    color          : '#555555',
    border         : '0',
    padding        : '0px 0',
    transition     : 'all 150ms ease 0s',
    minHeight      : '50px',
    display        : 'block',
  },
  brand: {
    color     : THEME.grey,
    fontSize  : 22,
    fontWeight: 400,
    marginLeft: 30,
  },
  container: {
    ...containerFluid,
    minHeight: '50px',
  },
  flex: {
    flex: 1,
  },
  title: {
    ...defaultFont,
    lineHeight       : '30px',
    fontSize         : '18px',
    borderRadius     : '3px',
    textTransform    : 'none',
    color            : 'inherit',
    paddingTop       : '0.625rem',
    paddingBottom    : '0.625rem',
    margin           : '0 !important',
    '&:hover,&:focus': {
      background: 'transparent',
    },
  },
  primary: {
    backgroundColor: primaryColor,
    color          : '#FFFFFF',
    ...defaultBoxShadow,
  },
  info: {
    backgroundColor: infoColor,
    color          : '#FFFFFF',
    ...defaultBoxShadow,
  },
  success: {
    backgroundColor: successColor,
    color          : '#FFFFFF',
    ...defaultBoxShadow,
  },
  warning: {
    backgroundColor: warningColor,
    color          : '#FFFFFF',
    ...defaultBoxShadow,
  },
  danger: {
    backgroundColor: dangerColor,
    color          : '#FFFFFF',
    ...defaultBoxShadow,
  },
  sidebarMinimize: {
    float  : 'left',
    padding: '0 0 0 15px',
    display: 'block',
    color  : '#555555',
  },
  sidebarMiniIcon: {
    width : '20px',
    height: '17px',
  },
}));
